import './Component/GlobalJQuery'

// Import Twitter Bootstrap v4
import 'bootstrap'

// Import webfonts
import 'typeface-roboto'
import 'typeface-belleza'

// Import lazysizes
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/bgset/ls.bgset'

// Import and initialize medium-zoom
import mediumZoom from 'medium-zoom'
mediumZoom('[data-action="zoom"]')

// Import components
import './Component/FontAwesome'
// TODO: disable for now - we just need the default bootstrap dropdown
//import './Component/Navigation'
import './Component/SlickCarousel'
import './Component/Tooltip'
import './Component/SmoothScroll'

import '../../../../Grimm.Blog/Resources/Private/JavaScript/Blog'
import '../../../../../Packages/Tms/Tms.Dialog/Resources/Private/JavaScript/Dialog'

// Styles
import '../Styles/App.scss'